import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';


const ShiftContextMenu = ({ x, y, onClose, shiftData, setHasCopiedShift }) => {

  useEffect(() => {
    let ignore = true;

    const handleClickOutside = () => {
      if (ignore) {
        ignore = false;
        return;
      }
      onClose();
    };

    const timeout = setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
    }, 100);

    return () => {
      clearTimeout(timeout);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [onClose]);

  const handleCopy = async () => {
    try {
      // Copiar el objeto como JSON en el portapapeles
      await navigator.clipboard.writeText(JSON.stringify(shiftData));
      localStorage.setItem('copiedShift', JSON.stringify(shiftData));
      if (setHasCopiedShift) {
        setHasCopiedShift(true); // ✅ activamos botón Cancel Copy
      }

      alert("Shift copied");

    } catch (err) {
      console.error("Error copiando shift:", err);
    }
    onClose();
  };


  return ReactDOM.createPortal(
    <ul
      style={{
        position: 'fixed',
        top: y,
        left: x,
        backgroundColor: '#111827',
        color: 'white',
        padding: '8px',
        borderRadius: '6px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
        zIndex: 9999,
        listStyle: 'none',
        minWidth: '130px',
      }}
    >
      <li onClick={(e) => {
        e.stopPropagation();
        handleCopy();
      }} style={{ padding: '6px', cursor: 'pointer' }}>📋 Copy</li>
    </ul>,
    document.body
  );

};

export default ShiftContextMenu;

